define.alias("shared/components/shared/ui/switcher/list", "settings/components/shared/ui/switcher/list");